import { Info } from '@phosphor-icons/react'
import React from 'react'

const Verified = ({heading, content, isVerified, cta, helpText }) => {
  return (
    <div className='flex flex-col gap-3'>
      <div className='heading-16'>{heading}</div>
      <div className='flex justify-between items-center gap-7'>
        <div className = 'text-16 text-grey-70 flex-1'>{content}</div>
        {isVerified && (<div className='label-14 text-primary-green'>Verified</div>)}
        {cta}
      </div>
      {helpText && (<div className="flex items-center gap-1">
        <Info size={12} weight="regular" color="#878787" />
        <div className="text-grey-70 text-12">{helpText}</div>
      </div>)}
    </div>
  )
}

export default Verified